import type { PropsWithChildren } from "react";

import { useProjectReleaseGuard } from "../hooks/useProjectReleaseGuard";

export const ProjectReleaseGuard = ({ children }: PropsWithChildren) => {
  useProjectReleaseGuard();
  return <>{children}</>;
};
